module.exports = __webpack_public_path__ + "img/conWarp.a64b119e.png";